// extracted by mini-css-extract-plugin
export default {"notificationLoader":"saga_notificationLoader__PN0lZ"};